// Auto-extracted tab: incidents
import React, { useState, useEffect, useMemo, useCallback } from 'react';

/**
 * IncidentsTab - extracted from app.jsx
 * Original lines: 9357-9534
 * 
 * TODO: This component needs props passed from AppContent:
 * - darkMode, scenarios, thresholds, etc.
 * - All the state and handlers it uses
 */
export function IncidentsTab(props) {
  // Original render content (needs refactoring to use props):
  return (
    <>
          <div className="space-y-6">
            {/* Summary Stats */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              <div className={`p-4 rounded-xl ${darkMode ? "bg-slate-800/50 border border-slate-700" : "bg-white border border-slate-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-white" : "text-slate-900"}`}>
                  {incidents.filter(i => !['resolved', 'closed'].includes(i.status)).length}
                </div>
                <div className={`text-sm ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Open Incidents</div>
              </div>
              <div className={`p-4 rounded-xl ${darkMode ? "bg-red-900/30 border border-red-800" : "bg-red-50 border border-red-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-red-400" : "text-red-700"}`}>
                  {incidents.filter(i => i.severity === 'critical' && !['resolved', 'closed'].includes(i.status)).length}
                </div>
                <div className={`text-sm ${darkMode ? "text-red-300" : "text-red-600"}`}>Critical Open</div>
              </div>
              <div className={`p-4 rounded-xl ${darkMode ? "bg-amber-900/30 border border-amber-800" : "bg-amber-50 border border-amber-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-amber-400" : "text-amber-700"}`}>
                  {incidents.filter(i => i.sla_breached).length}
                </div>
                <div className={`text-sm ${darkMode ? "text-amber-300" : "text-amber-600"}`}>SLA Breached</div>
              </div>
              <div className={`p-4 rounded-xl ${darkMode ? "bg-blue-900/30 border border-blue-800" : "bg-blue-50 border border-blue-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-blue-400" : "text-blue-700"}`}>
                  {incidents.filter(i => i.reportable_to_regulators).length}
                </div>
                <div className={`text-sm ${darkMode ? "text-blue-300" : "text-blue-600"}`}>Regulatory Reportable</div>
              </div>
              <div className={`p-4 rounded-xl ${darkMode ? "bg-emerald-900/30 border border-emerald-800" : "bg-emerald-50 border border-emerald-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-emerald-400" : "text-emerald-700"}`}>
                  {incidents.filter(i => i.status === 'closed').length}
                </div>
                <div className={`text-sm ${darkMode ? "text-emerald-300" : "text-emerald-600"}`}>Closed (All Time)</div>
              </div>
            </div>
            
            {/* Incident List */}
            <Card 
              darkMode={darkMode} 
              title="Incident Register" 
              subtitle="Security and operational incidents"
              actions={
                <div className="flex gap-2">
                  <Button variant="ghost" size="sm" onClick={loadIncidentData} disabled={incidentLoading}>
                    <Icons.Refresh className={incidentLoading ? "animate-spin" : ""} />
                  </Button>
                  <Button variant="primary" size="sm" onClick={() => setIncidentModal({ open: true, incident: null })}>
                    <Icons.Plus /> Report Incident
                  </Button>
                </div>
              }
            >
              {/* Filters */}
              <div className="flex flex-wrap gap-3 mb-4">
                <select 
                  value={incidentFilter.severity} 
                  onChange={e => setIncidentFilter({...incidentFilter, severity: e.target.value})}
                  className={`px-3 py-1.5 rounded-lg text-sm ${darkMode ? "bg-slate-700 border-slate-600 text-white" : "bg-white border-slate-300 text-slate-900"} border`}
                >
                  <option value="all">All Severities</option>
                  <option value="critical">Critical</option>
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
                <select 
                  value={incidentFilter.status} 
                  onChange={e => setIncidentFilter({...incidentFilter, status: e.target.value})}
                  className={`px-3 py-1.5 rounded-lg text-sm ${darkMode ? "bg-slate-700 border-slate-600 text-white" : "bg-white border-slate-300 text-slate-900"} border`}
                >
                  <option value="all">All Statuses</option>
                  <option value="open">Open</option>
                  <option value="investigating">Investigating</option>
                  <option value="contained">Contained</option>
                  <option value="remediation">Remediation</option>
                  <option value="resolved">Resolved</option>
                  <option value="closed">Closed</option>
                </select>
              </div>
              
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className={darkMode ? "bg-slate-800/50" : "bg-gradient-to-r from-slate-50 to-slate-100/80"}>
                    <tr>
                      <th className={`text-left py-3.5 px-4 font-semibold ${darkMode ? "text-slate-300" : "text-slate-700"}`}>ID</th>
                      <th className={`text-left py-3.5 px-4 font-semibold ${darkMode ? "text-slate-300" : "text-slate-700"}`}>Title</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Type</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Severity</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Status</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>SLA</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Detected</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {incidents
                      .filter(i => incidentFilter.severity === 'all' || i.severity === incidentFilter.severity)
                      .filter(i => incidentFilter.status === 'all' || i.status === incidentFilter.status)
                      .map(incident => {
                      const slaRemaining = incident.sla_deadline ? Math.round((new Date(incident.sla_deadline) - new Date()) / (1000 * 60 * 60)) : null;
                      return (
                        <tr key={incident.id} className={`${darkMode ? "border-slate-700/50 hover:bg-slate-800/50" : "border-slate-100 hover:bg-slate-50"} border-b`}>
                          <td className={`py-3 px-2 font-mono ${darkMode ? "text-blue-400" : "text-blue-600"}`}>{incident.incident_number}</td>
                          <td className="py-3 px-2">
                            <div className={`font-medium ${darkMode ? "text-white" : "text-slate-900"}`}>{incident.title}</div>
                            {incident.reportable_to_regulators && (
                              <span className={`text-xs ${darkMode ? "text-red-400" : "text-red-600"}`}>⚠️ Regulatory Reportable</span>
                            )}
                          </td>
                          <td className={`py-3 px-2 ${darkMode ? "text-slate-300" : "text-slate-700"}`}>{incident.incident_type?.replace('_', ' ')}</td>
                          <td className="py-3 px-2">
                            <Badge variant={incident.severity}>{incident.severity}</Badge>
                          </td>
                          <td className="py-3 px-2">
                            <span className={`px-2 py-0.5 rounded-full text-xs ${
                              incident.status === 'closed' ? (darkMode ? 'bg-emerald-900/50 text-emerald-400' : 'bg-emerald-100 text-emerald-700') :
                              incident.status === 'resolved' ? (darkMode ? 'bg-blue-900/50 text-blue-400' : 'bg-blue-100 text-blue-700') :
                              (darkMode ? 'bg-amber-900/50 text-amber-400' : 'bg-amber-100 text-amber-700')
                            }`}>
                              {incident.status}
                            </span>
                          </td>
                          <td className="py-3 px-2">
                            {incident.sla_breached ? (
                              <span className={`text-xs font-medium ${darkMode ? "text-red-400" : "text-red-600"}`}>⚠️ Breached</span>
                            ) : slaRemaining !== null && slaRemaining > 0 ? (
                              <span className={`text-xs ${slaRemaining < 4 ? (darkMode ? "text-amber-400" : "text-amber-600") : (darkMode ? "text-slate-500" : "text-slate-600")}`}>
                                {slaRemaining}h remaining
                              </span>
                            ) : (
                              <span className={`text-xs ${darkMode ? "text-slate-500" : "text-slate-500"}`}>-</span>
                            )}
                          </td>
                          <td className={`py-3 px-2 ${darkMode ? "text-slate-300" : "text-slate-700"}`}>
                            {new Date(incident.detected_at).toLocaleDateString()}
                          </td>
                          <td className="py-3 px-2">
                            <div className="flex gap-1">
                              <Button variant="ghost" size="xs" onClick={() => setIncidentDetailModal({ open: true, incident })}>
                                <Icons.Eye />
                              </Button>
                              <Button variant="ghost" size="xs" onClick={() => openIncidentEdit(incident)}>
                                <Icons.Edit />
                              </Button>
                              <Button variant="ghost" size="xs" onClick={() => openDeleteModal("incident", incident)}>
                                <Icons.Trash className="w-4 h-4 text-red-500" />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    {incidents.length === 0 && (
                      <tr>
                        <td colSpan={8} className="p-4">
                          <EducationalEmptyState
                            title="No incidents recorded"
                            examinerSays="How do you track compliance incidents? Show me your incident response process and escalation procedures."
                            example="Late SAR Filing - Incident reported 2024-02-15. SAR #12345 filed 2 days past deadline due to system outage. Root cause: backup process failed. Corrective action: automated backup monitoring implemented."
                            templates={[
                              { name: "Late Filing Incident", type: "late_filing" },
                              { name: "System Outage", type: "system_outage" },
                              { name: "Data Breach", type: "data_breach" },
                              { name: "Compliance Violation", type: "compliance_violation" },
                            ]}
                            onAddBlank={() => setIncidentModal({ open: true, incident: null })}
                            onSelectTemplate={(t) => setIncidentModal({ open: true, incident: null, template: t.type })}
                            darkMode={darkMode}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
    </>
  );
}

export default IncidentsTab;
